// extracted by mini-css-extract-plugin
export default {"tag":"Fke4G","iconWrapper":"iXGXl","icon":"fd2lG","tagText":"rxJbP"};